<script>

import EmployeeForm from "@/components/users/EmployeeForm.vue";

export default {
    components: {EmployeeForm},
    data() {
        return {
            errors: {},
            loading: true,
            user: {},
            controller: new AbortController()
        }
    },
    methods: {

    },
    mounted() {
        axios.get(`/users/${this.$route.params.id}`, {
            signal: this.controller.signal
        }).then((response) => {
            this.user = response.data.data;
        }).finally(() => {
            this.loading = false;
        })
    },
    beforeUnmount() {
        this.controller.abort();
    }
}

</script>
<template>
    <div class="employee-edit">

        <loader :loading="loading"/>

        <employee-form v-if="!loading" :user="user"/>

    </div>
</template>
